module.exports = "https://www.gc-pro.gnp.com.mx/460e09f12e67309f282a09f3cc57a1f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/expand_less_24px.png
// module id = 245
// module chunks = 0